
// 1. Define a target asset string parameter matching the array list handled on the views

import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getCoingeckoMarketsPrices = (vs_currency = "usd") => async (dispatch) => {
  // Trigger standard loading state spinner wrappers
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    // 2. Call your local secure Laravel proxy controller endpoint path instead of external addresses
    const res = await commonService.get(`/client/coingecko/dashboard`, {
      params: { "vs_currency" : vs_currency }
    });
    
    const marketData = res.data;

    return marketData;
  } catch (err) {
    // Gracefully parse backend runtime validation or exception string configurations
    const message = err.response?.data?.message || err.message || err.toString();

    // Hook cleanly back into your centralized global response interceptor error handlers
    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    
    throw err;
  } finally {
    // Reset pending spinner animations
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
